import addEventListenerOnce from "./addEventListenerOnce";
import * as array from "./array";
import * as object from "./object";
import copyProps from "./copyProps";
import lowerFirst from "./lowerFirst";
import identity from "./identity";
import mergeData from "vue-functional-data-merge/dist/lib.common.js";
import memoize from "./memoize"
import observeDom from "./observe-dom";
import pluckProps from "./pluckProps";
import prefixPropName from "./prefixPropName";
import suffixPropName from "./suffixPropName";
import unPrefixPropName from "./unPrefixPropName";
import upperFirst from "./upperFirst";
import warn from "./warn";

export {
    addEventListenerOnce,
    array,
    copyProps,
    lowerFirst,
    identity,
    mergeData,
    memoize,
    object,
    observeDom,
    pluckProps,
    prefixPropName,
    suffixPropName,
    upperFirst,
    unPrefixPropName,
    warn
};



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/lib/utils/index.js
// module id = 17
// module chunks = 2